'use client';

import { ReactNode, useEffect, useState } from 'react';
import { Loader } from '@/app/components/loader';

type Props = {
  children: ReactNode;
  showLoader?: boolean;
};

export const ZustandHydrationBoundary = ({
  children,
  showLoader = true,
}: Props) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // Return a loader until Next.js rehydration completes
  return (
    <>
      {isHydrated ? (
        <>{children}</>
      ) : (
        <>
          {showLoader ? (
            <Loader
              className="bg-gray-50 py-j lg:py-i"
              color="#FA0E6A"
              size={80}
            />
          ) : null}
        </>
      )}
    </>
  );
};
